import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import fakeImage from '~/shared/assets/BluredTrendingNow.jpg';
import { Loader } from '~/shared/components';
import { useNavAndFilters } from '~/shared/services/charts';
import GridPage from './ChartsPage/GridPage';
import HeatmapPage from './ChartsPage/HeatmapPage';
import HorizontalBarChartPage from './ChartsPage/HorizontalBarChartPage';
import IframePage from './ChartsPage/IframePage';
import TableChartPage from './ChartsPage/TableChartPage';
import HeadlessTableChartPage from './ChartsPage/HeadlessTableChartPage';
import StackedBarChartPage from './ChartsPage/StackedBarChartPage';
import ScatterChartPage from './ChartsPage/ScatterChartPage';
import VideoPlayerPage from './ChartsPage/VideoPlayerPage';
import UserExpiredModal from './UserExpiredModal';

const AlignedLoader = styled(Loader)`
  left: calc(50% - 25px);
  top: calc(50% - 25px);
`;

const PageWrapper = styled.div`
  padding-top: 0;
  height: calc(100vh - 64px);
  background: #f5f5f5;
`;

export default function ChartsPage({ navHirarchy }: any) {
  const navigate = useNavigate();

  const [userExpiredModal, setUserExpiredModal] = useState<any>(undefined);

  const isUserExpired =
    navHirarchy[navHirarchy.length - 1]?.items[navHirarchy[navHirarchy.length - 1]?.items.length - 1].categories[
      navHirarchy[navHirarchy.length - 1]?.items[navHirarchy[navHirarchy.length - 1]?.items.length - 1].categories
        .length - 1
    ].name === 'UserExpired';

  useEffect(() => {
    if (isUserExpired) setUserExpiredModal('open');
  }, [isUserExpired]);

  const { navHirarchyItem }: any = useNavAndFilters(navHirarchy);

  if (!navHirarchyItem) navigate('/');

  if (isUserExpired)
    return (
      <PageWrapper>
        <img width="100%" src={fakeImage} alt="isUserExpired" />
        {userExpiredModal && <UserExpiredModal onClose={() => setUserExpiredModal(undefined)} />}
      </PageWrapper>
    );

  return (
    <PageWrapper>
      {navHirarchyItem?.type === 'bar' && <StackedBarChartPage navHirarchy={navHirarchy} />}
      {navHirarchyItem?.type === 'table' && <TableChartPage navHirarchy={navHirarchy} />}
      {navHirarchyItem?.type === 'headless-table' && <HeadlessTableChartPage navHirarchy={navHirarchy} />}
      {navHirarchyItem?.type === 'grid' && <GridPage navHirarchy={navHirarchy} isUserExpired={isUserExpired} />}
      {navHirarchyItem?.type === 'horizontalBar' && <HorizontalBarChartPage navHirarchy={navHirarchy} />}
      {navHirarchyItem?.type === 'iframe' && (
        <IframePage navHirarchy={navHirarchy} url={navHirarchyItem?.heatmap?.['data-source-uri']} />
      )}
      {navHirarchyItem?.type === 'scatter' && <ScatterChartPage navHirarchy={navHirarchy} />}
      {navHirarchyItem?.type === 'heatmap' && <HeatmapPage navHirarchy={navHirarchy} />}
      {navHirarchyItem?.type === 'gif' && <VideoPlayerPage navHirarchy={navHirarchy} />}
      {!navHirarchyItem?.type && <AlignedLoader />}
      {userExpiredModal && <UserExpiredModal onClose={() => setUserExpiredModal(undefined)} />}
    </PageWrapper>
  );
}
